"use strict";
/**
 * Created by Pankaj on 2019-12-20.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelEvents = void 0;
class PromoPanelEvents {
}
//Actually should be a APIEvent.
PromoPanelEvents.ACTION_SPIN_DATA = "actionSpinData";
PromoPanelEvents.PROMO_PANEL_OPENED = "promoPanelOpened"; //Listened for in some games (at least Perl Harbor)
PromoPanelEvents.PROMO_PANEL_CLOSED = "promoPanelClosed"; //Listened for in some games (at least Perl Harbor)
PromoPanelEvents.PROMO_PANEL_MINIMIZED = "promoPanelMinimized"; //Listened for in some games (at least Perl Harbor)
PromoPanelEvents.PROMO_PANEL_MAXIMIZED = "promoPanelMaximized"; //Listened for in some games (at least Perl Harbor)
exports.PromoPanelEvents = PromoPanelEvents;
//# sourceMappingURL=PromoPanelEvents.js.map